module.exports = __webpack_public_path__ + "static/media/blomsterstøv.2eeed412.m4a";